<template>
  <div class="container">
    <div class="block">
      <div class="title-wrap">
        <div class="title-name"><em @click="$router.push({ name: 'cloudServerManager' })">云服管理</em> <label><i class="el-icon-arrow-right"></i> {{$route.meta.title}}</label></div>
      </div>
      <div class="content-inner-wrapper">
        <div class="serverInfo">
          <img :src="currServ.image | setDefaultMapImg" />
          <div class="serverDetails">
            <p>云服名称：{{currServ.room_name}}({{currServ.id}})</p>
            <p>云服类型：{{currServ.room_type | getRoomType}}（{{currServ.player_max}}人）</p>
            <p>云服状态：{{currServ.stat | getState}}（{{currServ.expire_time | formatTime}}）<el-tag :type="isWarnDay(currServ.expire_time) ? 'danger' : 'success'" effect="dark" size="small">{{currServ.expire_time | remainderTime}}</el-tag></p>
            <p>描述：{{currServ.desc}}</p>
          </div>
        </div>
        <h2>云服</h2>
        <div class="serverDataList">
          <div class="serverDataItem" v-for="(item, index) in dataPanelList" :key="index">
            <h4>{{item.title}}</h4>
            <p class="itemVal">{{item.value | formatMoney}} <em v-if="item.value >= 10000">{{item.unit}}</em></p>
            <p class="itemTotal">累计{{item.total | formatMoney}}<em v-if="item.total >= 10000">{{item.unit}}</em></p>
          </div>
        </div>
        <h2>基础数据</h2>
        <div class="tablePreHeader">
          <div class="query-form">
            <el-form
              :inline="true"
              ref="baseForm"
              :rules="rules"
              :model="formInline"
              class="form-inline"
            >
              <el-form-item label="选择日期" prop="date" style="margin-right: 0">
                <el-date-picker
                  v-model="formInline.date"
                  type="daterange"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  @change="changeDate"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <div class="btn-query" @click="queryBaseTableFn">查找</div>
              </el-form-item>
            </el-form>
          </div>
          <div class="download-wrap" @click="exportFn('formInline')">
            <img src="../../images/pc/icon_export.png" />
            <span>导出详细数据</span>
          </div>
        </div>
        <div class="myTable-wrap">
          <el-table :data="baseData" stripe>
            <el-table-column
              align="center"
              prop="date"
              label="日期"
              width="160">
            </el-table-column>
            <el-table-column
              align="center"
              prop="player_count"
              label="游戏人数">
            </el-table-column>
            <el-table-column
              align="center"
              prop="total_time"
              label="游戏总时长(分)">
            </el-table-column>
            <el-table-column
              prop="avg_time"
              label="游戏人均时长(分)">
            </el-table-column>
            <el-table-column
              align="center"
              prop="contribution"
              label="贡献点">
            </el-table-column>
            <el-table-column
              align="center"
              prop="minibean"
              label="迷你豆">
            </el-table-column>
            <el-table-column
              align="center"
              prop="pay_count"
              label="付费人数">
            </el-table-column>
          </el-table>
        </div>
        <div class="data-filter-page">
          <el-pagination
            background
            layout="prev, pager, next, jumper"
            :total="basePagination.total"
            @current-change="bDPaginationChange"
          >
          </el-pagination>
        </div>
        <h2>广告数据</h2>
        <div class="tablePreHeader">
          <div class="query-form">
            <el-form
              :inline="true"
              ref="adForm"
              :rules="rules"
              :model="adFormInline"
              class="form-inline"
            >
              <el-form-item label="选择日期" prop="date" style="margin-right: 0">
                <el-date-picker
                  v-model="adFormInline.date"
                  type="daterange"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  @change="changeDate"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <div class="btn-query" @click="queryAdTableFn">查找</div>
              </el-form-item>
            </el-form>
          </div>
          <!-- <div class="download-wrap" @click="exportFn('adFormInline')">
            <img src="../../images/pc/icon_export.png" />
            <span>导出详细数据</span>
          </div> -->
        </div>
        <div class="myTable-wrap">
          <el-table :data="adData" stripe>
            <el-table-column
              fixed="left"
              prop="date"
              label="日期"
              align="center"
              width="120">
            </el-table-column>
            <el-table-column
              prop="trigger_count"
              width="160"
              align="center"
              label="触发器广告展示">
            </el-table-column>
            <el-table-column
              prop="trigger_income"
              width="160"
              align="center"
              label="触发器广告收入">
            </el-table-column>
            <el-table-column
              prop="shop_count"
              width="160"
              align="center"
              label="商店广告展示数">
            </el-table-column>
            <el-table-column
              prop="shop_income"
              width="160"
              align="center"
              label="商城广告收入">
            </el-table-column>
            <el-table-column
              prop="passcheck_count"
              width="160"
              label="通行证广告展示数">
            </el-table-column>
            <el-table-column
              prop="passcheck_income"
              width="160"
              align="center"
              label="通行证广告收入">
            </el-table-column>
            <el-table-column
              prop="ad_count"
              width="160"
              align="center"
              label="广告总展示数">
            </el-table-column>
            <el-table-column
              prop="ad_income"
              width="160"
              align="center"
              label="广告总收入">
            </el-table-column>
          </el-table>
        </div>
        <div class="data-filter-page">
          <el-pagination
            background
            layout="prev, pager, next, jumper"
            :total="adPagination.total"
            @current-change="aDPaginationChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixins from '../../mixins/data.mixins'
export default {
  mixins: [mixins]
}
</script>
<style src="../../style/common-pc.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
$--color-primary: #fd9b21;
.serverInfo{
  display: flex;
  justify-content: flex-start;
  align-content: center;
  img{
    width: 305px;
    height: 170px;
    margin-right: 20px;
  }
  .serverDetails{
    display: flex;
    flex-direction: column;
    justify-content: center;
    p{
      font-size: 14px;
      line-height: 20px;
      height: 20px;
      margin: 6px 0;
    }
  }
}
h2{
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #262626;
  line-height: 33px;
  margin: 28px 0 16px;
}
.serverDataList{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  .serverDataItem{
    width: 186px;
    height: 119px;
    background: #FAFAFA;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: flex-start;
    margin-right: 15px;
    // margin-bottom: 16px;
    padding-left: 18px;
    &:nth-child(5n){
      margin-right: 0;
    }
    h4{
      height: 21px;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #262626;
      line-height: 21px;
      margin-bottom: 11px;
    }
    .itemVal{
      height: 31px;
      font-size: 24px;
      font-family: MicrosoftYaHei;
      color: #FD9B21;
      line-height: 31px;
      margin-bottom: 6px;
      em{
        width: 16px;
        height: 21px;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #595959;
        line-height: 21px;
      }
    }
    .itemTotal{
      height: 21px;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #8C8C8C;
      line-height: 21px;
    }
  }
}
</style>
